<template>
  <div class="home__feature-item">
    <icon
      :name="icon"
      class="feature-item__icon"
      :style="{backgroundColor: background, color: color}"
    ></icon>
    <div class="feature-item__title">{{title}}</div>
    <div class="feature-item__text">{{text}}</div>
  </div>
</template>

<script>
import Icon from "../../../core/components/icon/Icon";

export default {
  name: "HomeFeatureItem",
  data() {
    return {
      active: 0
    };
  },
  props: {
    title: String,
    text: String,
    icon: String,
    color: String,
    background: String
  },
  components: {
    Icon
  }
};
</script>

<style scoped lang="scss">
.home__feature-item {
  max-width: 320px;
}

.feature-item__icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 8px;
  font-size: 28px;
}

.feature-item__title {
  width: 180px;
  font-family: "Playfair Display";
  line-height: 32px;
  font-size: 24px;
  font-weight: bold;
  letter-spacing: 0.3px;
  text-align: center;
  margin: auto;
  margin-bottom: 24px;
  color: #0d0d0d;
}

.feature-item__text {
  width: 320px;
  //font-family: SoleilLt;
  font-family: Lato;
  font-weight: 300;
  //font-weight: 300;
  font-size: 18px;
  letter-spacing: 0.23px;
  text-align: center;
  color: #4d4d4d;
}

@media (max-width: 1023px) {
  .home__feature-item {
    margin: 0 0 32px 0;
  }
}
</style>
